import React from 'react'
import {
    StyledZeus,
    StyledMain,
    StyledSidebar,
} from 'component-library/compositions/Zeus/Zeus.styled'
import { BaseCompositionProps } from '../types'
import { ThemeMargins, ContainerWidth } from 'component-library/__styling/settings/metrics'

export interface ZeusProps extends BaseCompositionProps {
    mainContent: React.ReactElement<any>
    sidebarContent: React.ReactElement<any>
    /** Stacks sidebar content underneath the main content, also modifies the breakpoint at which the sidebar collapses */
    stackSidebarContent?: boolean
    hasBackgroundFill?: boolean
    /** If true or undefined, will default to the outer margin of the theme */
    horizontalGutters?: boolean | keyof ThemeMargins
    /** If true or undefined, will default to the outer margin of the theme */
    verticalGutters?: boolean | keyof ThemeMargins
    verticalSpacing?: keyof ThemeMargins
    containerWidth?: ContainerWidth
}

export type Props = ZeusProps

export const Zeus: React.FC<Props> = ({
    mainContent,
    sidebarContent,
    hasBackgroundFill,
    horizontalGutters,
    verticalGutters,
    verticalSpacing,
    containerWidth,
    stackSidebarContent = false,
}) => {
    return (
        <StyledZeus
            stackSidebarContent={stackSidebarContent}
            hasBackgroundFill={hasBackgroundFill}
            horizontalGutters={horizontalGutters}
            verticalGutters={verticalGutters}
            verticalSpacing={verticalSpacing}
            containerWidth={containerWidth}
        >
            <StyledMain hasBackgroundFill={hasBackgroundFill}>{mainContent}</StyledMain>
            <StyledSidebar stackSidebarContent={stackSidebarContent}>
                {sidebarContent}
            </StyledSidebar>
        </StyledZeus>
    )
}
